import {post, get} from '@/common/utils/Http';

export default {
  createTopic: post('/subscribe/createTopic'),
  updateTopic: post('/subscribe/updateTopic'),
  getTopics: post('/subscribe/getTopics'),
  deleteTopic: post('/subscribe/deleteTopic'),
};
